import { ErrorReducer } from './error.reducer';

export const reducers = ErrorReducer;
